import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1c97e72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-flex lr y-center filter-box" }
const _hoisted_2 = { class: "filter-btn" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "date-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "故障发生时间"),
  /*#__PURE__*/_createElementVNode("div", null, "请选择准确的故障发生时间")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_fault_logs = _resolveComponent("fault-logs")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_config_provider = _resolveComponent("van-config-provider")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, {
      title: "选择故障日志",
      rightTxt: "确定",
      rightCanClick: _ctx.rightCanClick,
      onRightClick: _ctx.onRightClick
    }, null, 8, ["rightCanClick", "onRightClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = true))
        }, [
          _createTextVNode(_toDisplayString(_ctx.filterDateStr) + " ", 1),
          _createVNode(_component_van_icon, { name: "arrow-down" })
        ])
      ]),
      (_ctx.$store.getters.isMiniProgram)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRightClick && _ctx.onRightClick(...args))),
            class: _normalizeClass(_ctx.rightCanClick ? 'xag-effect' : 'xag-disabled')
          }, " 确定 ", 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_fault_logs, {
      class: "xag-container",
      filterDateStr: _ctx.filterDateStr,
      sn: _ctx.sn,
      onSelectLogs: _ctx.onSelectLogs
    }, null, 8, ["filterDateStr", "sn", "onSelectLogs"]),
    _hoisted_3,
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom",
      round: "",
      "safe-area-inset-bottom": "",
      class: "date-select-box network-point-popup"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_config_provider, { "theme-vars": _ctx.themeVars }, {
          default: _withCtx(() => [
            _createVNode(_component_van_datetime_picker, {
              onConfirm: _ctx.onConfirmDate,
              onCancel: _ctx.onCancelDate,
              modelValue: _ctx.filterDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterDate) = $event)),
              "max-date": _ctx.maxDate,
              title: "选择年月日",
              formatter: _ctx.formatter,
              type: "date"
            }, {
              title: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onConfirm", "onCancel", "modelValue", "max-date", "formatter"])
          ]),
          _: 1
        }, 8, ["theme-vars"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}